import api from './api';

export const getThreads = (spaceId, params = {}) =>
  api.get(`/spaces/${spaceId}/threads`, { params });

export const createThread = (spaceId, data) =>
  api.post(`/spaces/${spaceId}/threads`, data);

export const getThread = (spaceId, threadId) =>
  api.get(`/spaces/${spaceId}/threads/${threadId}`);

export const updateThread = (spaceId, threadId, data) =>
  api.patch(`/spaces/${spaceId}/threads/${threadId}`, data);

export const getMessages = (spaceId, threadId, params = {}) =>
  api.get(`/spaces/${spaceId}/threads/${threadId}/messages`, { params });

export const sendMessage = (spaceId, threadId, data) =>
  api.post(`/spaces/${spaceId}/threads/${threadId}/messages`, data);

export const editMessage = (spaceId, threadId, messageId, data) =>
  api.patch(`/spaces/${spaceId}/threads/${threadId}/messages/${messageId}`, data);

export const deleteMessage = (spaceId, threadId, messageId) =>
  api.delete(`/spaces/${spaceId}/threads/${threadId}/messages/${messageId}`);

export const markThreadRead = (spaceId, threadId) =>
  api.post(`/spaces/${spaceId}/threads/${threadId}/read`);

export const deleteThread = (spaceId, threadId) =>
  api.delete(`/spaces/${spaceId}/threads/${threadId}`);

export const toggleThreadLock = (spaceId, threadId) =>
  api.patch(`/spaces/${spaceId}/threads/${threadId}/lock`);
